import { Component, computed, inject, input } from '@angular/core';

import { ChdSlideToggle } from '@cp-produkte/cruise-hospitality-design';
import { TranslocoPipe } from '@jsverse/transloco';

import { FeatureToggleService } from '@permission';
import { ChdBackendService } from '@services';

@Component({
  selector: 'spa-backend-toggle',
  imports: [ChdSlideToggle, TranslocoPipe],
  templateUrl: './backend-toggle.component.html',
  styleUrl: './backend-toggle.component.scss',
})
export class BackendToggleComponent {
  private readonly chdBackendService = inject(ChdBackendService);
  private readonly featureToggleService = inject(FeatureToggleService);

  readonly labelAboveToggle = input(false);

  protected readonly hasBackendToggleFeature = this.featureToggleService.hasFeature('enable-dx-chd-ui-toggle');
  protected readonly isDxBackend = computed(() => this.chdBackendService.backend() === 'dx');

  protected onBackendToggleChange(change: boolean | CustomEvent<boolean>): void {
    const useDxBackend = typeof change === 'boolean' ? change : change.detail;
    const backendChanged = this.chdBackendService.setBackend(useDxBackend ? 'dx' : 'material');
    if (backendChanged) {
      window.location.reload();
    }
  }
}
